// extracted by mini-css-extract-plugin
module.exports = {"title_div":"Payment_title_div__3pVuQ","participationCompetition_div":"Payment_participationCompetition_div__3BGzJ"};